
import { Component, Vue } from 'vue-property-decorator'
import { UserModule } from '@/store/modules/user'

@Component({ name: 'TechTopbar' })
export default class TechTopbar extends Vue {
    private clock: string = '--:--:--'
    private theme: 'light' | 'dark' = 'light'
    private timer: number | null = null

    get isDark(): boolean {
        return this.theme === 'dark'
    }

    get pageTitle(): string {
        const t = this.$route.meta && (this.$route.meta as any).title
        return t || ''
    }

    private mounted() {
        // 读取已被 public/index.html 内联脚本写到 <html data-theme> 的值
        const attr = document.documentElement.getAttribute('data-theme')
        this.theme = attr === 'dark' ? 'dark' : 'light'
        this.updateClock()
        this.timer = window.setInterval(this.updateClock, 1000)
    }

    private beforeDestroy() {
        if (this.timer !== null) {
            window.clearInterval(this.timer)
            this.timer = null
        }
    }

    private backToOps() {
        this.$router.push('/dashboard')
    }

    private toggleTheme() {
        const next: 'light' | 'dark' = this.theme === 'dark' ? 'light' : 'dark'
        this.theme = next
        document.documentElement.setAttribute('data-theme', next)
        try {
            localStorage.setItem('pdm-theme', next)
        } catch (e) {
            /* localStorage 不可用时静默 */
        }
    }

    private updateClock() {
        const n = new Date()
        const t = n.toLocaleTimeString('zh-CN', { hour12: false })
        const d = n.toLocaleDateString('zh-CN', { month: '2-digit', day: '2-digit' })
        this.clock = `${d} ${t}`
    }

    // 预留：后续接入角色权限时使用（角色不足禁用某些按钮）
    private get role(): number {
        return UserModule.role
    }
}
